/**
 * Analytics Configuration
 */

export const ANALYTICS_CONFIG = {
    // Base page name structure: kporg:en:nat:mykp:wfr:home:[app]:[feature]:[detail]
    BASE_PAGE_NAME: 'kporg:en:nat:mykp:wfr:home',
    
    // Applications
    APPS: {
      CITIZENSHIP: 'citizenship',
      TUITION: 'tuition',
    },
  
    // Citizenship page names
    CITIZENSHIP_PAGES: {
      HOME: 'citizenship:home',
      APPLICANT: 'citizenship:applicant',
      EMPLOYMENT: 'citizenship:employment',
      FEE_SUMMARY: 'citizenship:fee-summary',
      SUBMIT_SUCCESS: 'citizenship:submit-success',
      UPLOAD_DOCUMENT_SUMMARY: 'citizenship:upload-document-summary',
      UPLOAD_DOCUMENT_DETAILS: 'citizenship:upload-document-details',
      MANAGER_PORTAL: 'citizenship:manager-portal',
      MANAGER_PORTAL_PAGE: 'citizenship:manager-portal-N', // N = page number
      MANAGER_PAID_HOURS: 'citizenship:manager-portal:paid-hours',
      MANAGER_PAID_HOURS_SAVED: 'citizenship:manager-portal:paid-hours-saved',
      MANAGER_APPLICATION_TAB: 'citizenship:manager-portal:application-tab',
      MANAGER_INFO_TAB: 'citizenship:manager-portal:manager-info-tab',
    },
  
    // Tuition page names
    TUITION_PAGES: {
      START: 'tuition:start',
      EMPLOYEE: 'tuition:employee',
      EMPLOYMENT_INFO: 'tuition:employment-info',
      PRIMARY_APPROVER: 'tuition:primary-approver-info',
      SCHOOL_INFO: 'tuition:school-info',
      CLASS_INFO: 'tuition:class-info',
      COMMENTS: 'tuition:comments',
      PARTICIPANTS_CONDITIONS: 'tuition:participants-conditions',
      SAVE_SUBMIT: 'tuition:save-submit',
      STATUS_DOCUMENTS: 'tuition:status-documents',
      MY_DOCUMENTS_TAB: 'tuition:my-documents-tab',
      DETAILS_TAB: 'tuition:details-tab',
      MANAGER_PORTAL: 'tuition:manager-portal',
      MANAGER_ADD_NOTES: 'tuition:manager-portal:add-notes',
      MANAGER_VIEW_APPLICANT: 'tuition:manager-portal:view-details:applicant',
      MANAGER_VIEW_EMPLOYMENT: 'tuition:manager-portal:view-details:employment',
      MANAGER_VIEW_SCHOOL: 'tuition:manager-portal:view-details:school',
      MANAGER_VIEW_CLASS: 'tuition:manager-portal:view-details:class',
      MANAGER_VIEW_OTHER_APPS: 'tuition:manager-portal:view-details:other-apps',
      MANAGER_VIEW_PAST_APPS: 'tuition:manager-portal:view-details:past-apps',
      EMPLOYEE_INFO_TAB: 'tuition:my-employee-info:employee-info-tab',
      EMPLOYEE_BALANCE_TAB: 'tuition:my-employee-info:employee-balance-tab',
    },
  
    // Error pages
    ERROR_PAGES: {
      DATE_VALIDATION: 'error:date-validation',
      APPLICATION_REJECTED: 'error:application-rejected',
      NUID_NOT_FOUND: 'error:nuid-not-found',
    },
  
    // Events
    EVENTS: {
      PAGE_VIEW: 'pageView',
      FORM_SUBMIT: 'formSubmit',
      FORM_SAVE: 'formSave',
      FORM_ERROR: 'formError',
      BUTTON_CLICK: 'buttonClick',
      SEARCH: 'search',
      APPROVAL: 'approval',
      DENIAL: 'denial',
      DOCUMENT_UPLOAD: 'documentUpload',
    },
  } as const;
  
  /**
   * Get full page name with base
   */
  export const getFullPageName = (pageKey: string): string => {
    return `${ANALYTICS_CONFIG.BASE_PAGE_NAME}:${pageKey}`;
  };
  
  /**
   * Get page name with pagination number
   */
  export const getPagedPageName = (basePage: string, pageNumber: number): string => {
    const pagedBasePage = basePage.replace('-N', `-${pageNumber}`);
    return `${ANALYTICS_CONFIG.BASE_PAGE_NAME}:${pagedBasePage}`;
  };